import { Address } from 'features/Directory'
import moment from 'moment'
import { FC } from 'react'
import { DateFormatMoment } from 'utils/date'
import { useI18n } from 'utils/localisation'

import { msToDays } from '../formatDate'
import { TTransportModeWithShip } from '../QuoteSheet/QuoteOption/QuoteTransportPlan'
import { departureDate, IQuoteOption } from '../QuoteSheet/QuoteSheetOption'
import { BookingTimelineItem } from './BookingTimelineItem'
import { getRouteDistance } from './PostRouteSchedule'

type PreRouteScheduleProps = {
  option: IQuoteOption
}

export const PreRouteSchedule: FC<PreRouteScheduleProps> = ({ option }) => {
  const { translate } = useI18n()
  const { routeQuotes } = option
  const { preQuote } = routeQuotes

  if (!preQuote) {
    return null
  }

  const {
    route: { journey },
  } = preQuote

  return (
    <>
      <BookingTimelineItem
        isFirstLeg
        timelineContent={{
          timestamp: {
            label: translate('quote_sheet-option-transport_plan-estimated_pickup'),
            value: moment(departureDate(option)).format(DateFormatMoment.DATE),
          },
          description: {
            label: translate('quote_sheet-option-transport_plan-origin'),
            value: (journey.origin as Address).city || (journey.origin as Address).country,
          },
        }}
      />
      <BookingTimelineItem
        icon={preQuote.mode as TTransportModeWithShip}
        timelineContent={{
          timestamp: {
            label: 'Estimated duration',
            value: translate('quote_sheet-option-transport_plan-pre_run-estimate', {
              days: msToDays(preQuote.route.duration ?? 0),
            }),
          },
          description: {
            label: `${preQuote.mode} ${translate('quote_sheet-option-transport_plan-pre_run-pre_carriage')}`,
            value: getRouteDistance(preQuote.route),
          },
        }}
      />
    </>
  )
}
